import httpClient from './httpClient';
import { buildQueryString } from '../utils/queryBuilder';
import { parseApiError } from '../utils/errorHandler';
import { mapRouteListItem } from './routeService';

const ENDPOINT = '/api/motorista/rotas';

/**
 * Lista cabeçalhos de roteiros do motorista autenticado.
 * GET /api/motorista/rotas
 *
 * @param {{ page?: number, size?: number, sort?: string, state?: string }} params
 */
async function list({ page = 0, size = 20, sort = 'id,desc', state } = {}) {
    const filters = {};
    if (state) filters.state = state;

    const queryString = buildQueryString({ page, size, sort, filters });
    const response = await httpClient.get(`${ENDPOINT}?${queryString}`);
    if (!response.ok) {
        throw await parseApiError(response);
    }

    const json = await response.json();
    const content = (json.content || []).map(mapRouteListItem);
    const pageMeta = json.page || {};
    const totalPages = pageMeta.totalPages ?? 0;
    const pageNumber = Math.max(0, pageMeta.number ?? 0);

    return {
        content,
        page: {
            number: pageNumber,
            totalPages,
            first: totalPages === 0 || pageNumber === 0,
            last: totalPages === 0 || pageNumber >= totalPages - 1,
        },
    };
}

/**
 * Detalhe de roteiro do motorista autenticado.
 * GET /api/motorista/rotas/{id}
 *
 * @param {string|number} id
 */
async function get(id) {
    const response = await httpClient.get(`${ENDPOINT}/${encodeURIComponent(id)}`);
    if (!response.ok) {
        throw await parseApiError(response);
    }
    return response.json();
}

/**
 * Inicia a execução do roteiro pelo motorista autenticado.
 * POST /api/motorista/rotas/{id}/iniciar
 *
 * @param {string|number} id
 */
async function start(id) {
    const response = await httpClient.post(`${ENDPOINT}/${encodeURIComponent(id)}/iniciar`, {});
    if (!response.ok) {
        throw await parseApiError(response);
    }
}

/**
 * Atualiza o estado de um ponto do roteiro (motorista).
 * POST /api/motorista/rotas/{id}/pontos/{routePointId}/atualizar?customerId=...
 *
 * @param {string|number} routeId
 * @param {string|number} pointId
 * @param {string|number} customerId
 * @param {{ state: string, images?: number[], comment?: string|null }} payload
 */
async function updatePoint(routeId, pointId, customerId, payload) {
    const params = new URLSearchParams();
    params.set('customerId', String(customerId));

    const body = {
        state: payload.state,
        images: Array.isArray(payload.images) ? payload.images : [],
    };

    const comment = payload.comment != null ? String(payload.comment).trim() : '';
    if (comment) {
        body.comment = comment;
    }

    const response = await httpClient.post(
        `${ENDPOINT}/${encodeURIComponent(routeId)}/pontos/${encodeURIComponent(pointId)}/atualizar?${params.toString()}`,
        body,
    );
    if (!response.ok) {
        throw await parseApiError(response);
    }
}

const driverRouteService = {
    list,
    get,
    start,
    updatePoint,
};

export default driverRouteService;
